import Add16 from '@carbon/icons-react/es/add/16';
import React, { FC, useCallback, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'components/atoms/button';
import { Option } from 'components/atoms/select';
import { AddExclusionWrapper, UserListSelect } from './components';
import { TimesheetExcludedUsers } from './types';
import { useAddExcludedUsers } from './use-add';
import { asNonRemovedList } from './utils';

interface Props {
  userOptions: Option[];
  isUserOptionsLoading: boolean;
  excludedUsers: TimesheetExcludedUsers;
}
export const AddUsers: FC<Props> = ({
  userOptions,
  isUserOptionsLoading,
  excludedUsers,
}) => {
  const noAlreadyExcludedUsers = useMemo(() => {
    const excludedUserIds = asNonRemovedList(excludedUsers);

    return userOptions.filter(
      ({ value }) => !excludedUserIds.includes(Number(value)),
    );
  }, [excludedUsers, userOptions]);
  const [selectedUsers, setSelectedUsers] = useState<Option[]>([]);
  const addUsers = useAddExcludedUsers();
  const addHandler = useCallback(() => {
    addUsers(selectedUsers.map(({ value }) => Number(value)));
    setSelectedUsers([]);
  }, [addUsers, selectedUsers]);
  const onChangeHandler = useCallback((newOptions) => {
    setSelectedUsers(newOptions ?? []);
  }, []);
  const filterOption = useCallback(({ data }, input) => {
    const { label = '', description = '' } = data;

    return (
      label.toLowerCase().includes(input.toLowerCase()) ||
      description.toLowerCase().includes(input.toLowerCase())
    );
  }, []);

  return (
    <AddExclusionWrapper>
      <UserListSelect
        options={noAlreadyExcludedUsers}
        isMulti
        closeMenuOnSelect={false}
        value={selectedUsers}
        onChange={onChangeHandler}
        type="user"
        isDisabled={isUserOptionsLoading}
        isLoading={isUserOptionsLoading}
        filterOption={filterOption}
        components={{
          DropdownIndicator: () => null,
          IndicatorSeparator: () => null,
        }}
      />
      <Button
        icon={<Add16 />}
        iconPlacement="right"
        type="primary"
        disabled={selectedUsers.length === 0}
        onClick={addHandler}
      >
        <FormattedMessage id="add" />
      </Button>
    </AddExclusionWrapper>
  );
};
